module.exports = __webpack_public_path__ + "static/media/1.75d3e3fe.png";